import { Suspense } from 'react';
import { Skeleton } from '@mui/material';
import GlobalErrorBoundary from 'components/GlobalErrorBoundary';
import GridErrorBoundaryFallback from './GridErrorBoundaryFallback';

interface GridWrapperProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  datadogSource?: string;
}

const SuspenseBoundary = ({ children, fallback, datadogSource }: GridWrapperProps) => {
  return (
    <GlobalErrorBoundary
      FallbackComponent={GridErrorBoundaryFallback}
      datadogSource={datadogSource}
    >
      <Suspense
        fallback={fallback ??
          <Skeleton
            width={'100%'}
            height={'40px'}
            sx={{ transform: 'translateY(0)', borderRadius: '8px', mb: 2 }}
          />
        }
      >
        {children}
      </Suspense>
    </GlobalErrorBoundary>
  );
};

export default SuspenseBoundary;